var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"upgrade-to-premium-button",attrs:{"type":"button"},on:{"click":_vm.openPaywall}},[_vm._v(" UPGRADE TO PREMIUM ")])
}
var staticRenderFns = []

export { render, staticRenderFns }